import React, { useState, useEffect, useContext } from 'react'
import { useFormik } from 'formik'
import EmployeeContext from '@/product/context/employee/empContext'
import NoRecordsFound from '../../atoms/NoRecordsFound'
import PrimaryButton from '../../atoms/PrimaryButton'
import CheckBox from '../../atoms/CheckBox'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'

const EmpPermission = (props) => {
    const employeeContext = useContext(EmployeeContext)
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [permissionDetails, setPermissionDetails] = useState([])
    const [permissionValues, setPermissionValues] = useState([])
    const {
        single_employee,
        getSingleEmployee,
        employeeAction,
        changeUserStatus,
        responseStatus: responseStatusEmployee,
    } = employeeContext

    const formik = props.formik

    useEffect(() => {
        if (responseStatusEmployee) {
            if (responseStatusEmployee.status === 'success') {
                if (responseStatusEmployee.from === 'employeeAction') {
                    formik.resetForm()
                    if (props?.cancelFunction) {
                        props.cancelFunction()
                    }
                    setIsLoading(false)
                }
            }
        }
    }, [responseStatusEmployee])

    useEffect(() => {
        if (props?.data && Object.keys(props?.data).length) {
            let employeeData = props.data.emp_permissions
            console.log(props.formik, 'jkkk')
            formik.values.emp_permissions = employeeData.split(',').length
                ? employeeData.split(',')
                : []

            console.log(employeeData.split(','), 'permission')
            setReload(!reload)
        }
        if (props.permissionDetails && props.permissionDetails.length) {
            console.log(props.permissionDetails, 'periii')
            setPermissionDetails(props.permissionDetails[0].options)
        } else {
            setPermissionDetails([])
        }
    }, [props.data])

    // useEffect(() => {
    //     if (props.additionalfieldUpdate) {
    //         props.additionalfieldUpdate(formik.values)
    //     }
    // }, [formik.values])

    const [showCount, setShowCount] = useState(10)
    const [isShowMore, setShowMore] = useState(false)

    const handleShowMore = () => {
        if (isShowMore) {
            setShowMore(false)
            setShowCount(10)
        } else {
            setShowMore(true)
            setShowCount(permissionDetails?.length)
        }
    }

    return (
        <div className="table-responsive dpTable">
            {permissionDetails.length ? (
                <>
                    {props.selectDetails &&
                        mapData({
                            formik: formik,
                            data: props.selectDetails,
                        })}
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <table className="table text-left">
                            <tbody>
                                {permissionDetails
                                    .slice(0, showCount)
                                    .map((data, index) => (
                                        <tr key={data.id}>
                                            <td>{data.description}</td>
                                            <td>
                                                <div>
                                                    {props.readOnly ? (
                                                        formik.values[
                                                            'emp_permissions'
                                                        ]?.indexOf(data.id) !==
                                                        -1 ? (
                                                            <span className="material-icons">
                                                                done
                                                            </span>
                                                        ) : (
                                                            <span className="material-icons">
                                                                clear
                                                            </span>
                                                        )
                                                    ) : (
                                                        <CheckBox
                                                            name={
                                                                'emp_permissions'
                                                            }
                                                            label={''}
                                                            checked={
                                                                formik.values[
                                                                    'emp_permissions'
                                                                ]?.indexOf(
                                                                    data.id
                                                                ) !== -1
                                                            }
                                                            value={data.id}
                                                            onChange={
                                                                formik.handleChange
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>

                        <Button
                            onClick={handleShowMore}
                            className="permShowMoreBtn"
                        >
                            {`Show ${isShowMore ? 'less' : 'more'}`}
                        </Button>
                        {!props.readOnly && (
                            <PrimaryButton
                                id="notify_save"
                                type="submit"
                                label={'Save'}
                                btnSize="notifBtn"
                            />
                        )}
                    </form>
                </>
            ) : (
                <NoRecordsFound />
            )}
        </div>
    )
}

export default EmpPermission
